import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { NotebookStore } from '../stores/NotebookStore';
import { Cell } from './Cell';
import { PlusIcon } from '@phosphor-icons/react';

interface NotebookProps {
  store: NotebookStore;
  readonly: boolean;
  className?: string;
}

export const Notebook = observer(
  ({ store, readonly, className }: NotebookProps) => {
    useEffect(() => {
      if (!store.notebookContent?.cells) {
        return;
      }
      const firstCell = store.notebookContent.cells[0];
      if (firstCell) {
        store.activateCell(firstCell.id);
      }
    }, [store.notebookContent]);
    return (
      <div
        className={`pt-4 pb-72 min-h-0 flex-1 overflow-auto ${className || ''}`}
      >
        {store.notebookContent?.cells &&
          store.notebookContent.cells.map((cell, i) => {
            return (
              <div key={cell.id}>
                <Cell
                  cell={cell}
                  store={store}
                  index={i}
                  readonly={readonly}
                  activeCellId={store.activeCellId}
                />
              </div>
            );
          })}
      </div>
    );
  }
);

interface CellDividerProps {
  onClick: () => void;
}

export const CellDivider = ({ onClick }: CellDividerProps) => {
  const [hovering, setHovering] = useState(false);

  return (
    <div
      className="w-full h-4 flex justify-center items-center rounded-sm hover:bg-neutral-200"
      onMouseEnter={() => setHovering(true)}
      onMouseOut={() => setHovering(false)}
      onClick={onClick}
    >
      {hovering && <PlusIcon size={16} />}
    </div>
  );
};
